import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";

const BTN = "px-4 py-2 rounded-full border-[3px] border-[#374151] font-black text-sm shadow-[0_3px_0_0_#374151] active:translate-y-[3px] active:shadow-none";

function RequestCard({ q, cats, onDone, api }) {
  const [cat, setCat] = useState(q.public_request?.category_id || "");
  const decide = async (action) => {
    try { await api.post(`/admin/publish-requests/${q.id}/${action}`, { category_id: cat || null }); toast.success(action === "approve" ? "Quiz is now public" : "Request rejected"); onDone(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Failed"); }
  };
  return (
    <div className="sticker-card p-5" data-testid={`publish-request-${q.id}`}>
      <p className="font-black text-lg">{q.title}</p>
      <p className="text-sm text-slate-500">by {q.owner_name || "teacher"} • {q.questions.length} question(s)</p>
      {q.public_request?.note && <p className="text-sm mt-1">Note: {q.public_request.note}</p>}
      <div className="mt-3 space-y-1 text-sm">
        {q.questions.slice(0, 3).map((x, i) => <p key={x.id}><b>{i + 1}.</b> {x.text} <span className="text-slate-400">({x.options[x.correct_index]})</span></p>)}
        {q.questions.length > 3 && <p className="text-slate-500">+ {q.questions.length - 3} more…</p>}
      </div>
      <div className="mt-4 flex gap-2 flex-wrap items-center">
        <select value={cat} onChange={(e) => setCat(e.target.value)} data-testid={`publish-category-${q.id}`}
          className="px-3 py-2 rounded-lg border-[2px] border-[#374151] font-bold bg-white">
          <option value="">Choose category…</option>
          {cats.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
        </select>
        <button onClick={() => decide("approve")} data-testid={`approve-publish-${q.id}`} className={`${BTN} bg-[var(--tp-success)] text-white`}>Make public</button>
        <button onClick={() => decide("reject")} data-testid={`reject-publish-${q.id}`} className={`${BTN} bg-white`}>Reject</button>
      </div>
    </div>
  );
}

export default function AdminPublishRequests({ api }) {
  const [rows, setRows] = useState([]);
  const [cats, setCats] = useState([]);
  const load = useCallback(() => api.get("/admin/publish-requests").then((r) => setRows(r.data)), [api]);
  useEffect(() => { load(); api.get("/categories").then((r) => setCats(r.data)); }, [load, api]);
  return (
    <div className="space-y-4" data-testid="admin-publish-requests">
      {rows.length === 0 && <p className="text-slate-500">No teacher quizzes waiting to go public.</p>}
      {rows.map((q) => <RequestCard key={q.id} q={q} cats={cats} api={api} onDone={load} />)}
    </div>
  );
}
